import { GridWithGaps } from '@dreamstack/feature-components/src/layout/MainGrid'
import { HeadingH3 } from '@dreamstack/feature-components/src/layout/Texts'
import { useTranslation } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import { RegionAverageTile } from '../../../components/RegionAverageTile'
import { CandleStickGraph } from '../CandleStickGraph'
import { AVG_BUY_PRICES } from './data/durchschnittliche_kaufpreise'
import { useDataForAverageTiles } from './libs/useDataForAverageTiles'
import { useDataForCandleStickGraph } from './libs/useDataForCandleStickGraph'

export interface RegionAvgBuyPricesCandleStickProps {
  customProps: RegionAvgBuyPricesCandleStickCustomProps
}

export type RegionAvgBuyPricesCandleStickCustomProps = {
  region: string
}

export const RegionAvgBuyPricesCandleStick: FunctionComponent<
  React.PropsWithChildren<RegionAvgBuyPricesCandleStickProps>
> = ({ customProps }) => {
  const region = customProps.region
  const t = useTranslation()
  const tilesData = useDataForAverageTiles(customProps.region)

  const formatted_data = useDataForCandleStickGraph(
    region,
    AVG_BUY_PRICES,
    'kauf'
  )

  const data = [
    {
      // TODO: add Translation

      id: `${t(
        'accentro:districtLandingPageGraphs.candleStickGraph.purchasePrice'
      )} (m²)`,
      data: formatted_data,
    },
  ]

  if (region) {
    return (
      <div className="space-y-px-64 md:space-y-px-96">
        <GridWithGaps>
          <div className="col-span-full mb-px-32 md:mb-px-80">
            <CandleStickGraph
              data={data}
              title={`${t(
                'accentro:districtLandingPageGraphs.candleStickGraph.purchasePrice'
              )} (m²) in ${region}`}
              rangeStep={2000}
            />
          </div>
        </GridWithGaps>
        <GridWithGaps>
          <div className="flex flex-col col-span-full md:col-auto md:flex-row justify-start gap-px-16">
            <div className="sm:w-min sm:whitespace-nowrap gap-px-12">
              <HeadingH3>
                {t(
                  'accentro:districtLandingPageGraphs.regionAverageGraph.existingBuilding'
                )}
              </HeadingH3>
              <RegionAverageTile data={tilesData[1]} />
            </div>
            <div className="sm:w-min sm:whitespace-nowrap gap-px-12">
              <HeadingH3>
                {t(
                  'accentro:districtLandingPageGraphs.regionAverageGraph.newBuilds'
                )}
              </HeadingH3>
              <RegionAverageTile data={tilesData[5]} />
            </div>
          </div>
        </GridWithGaps>
      </div>
    )
  } else
    return (
      <>
        {t(
          'accentro:districtLandingPageGraphs.regionPieChart.mustSelectRegion'
        )}
      </>
    )
}
